import { OrderFilter } from '@/types/orders.type';
import { BSON } from 'realm-web';
import { getDateRangeByFilter } from './getDateRangeByFilter';

export const buildMatchQuery = (companyId: string, filter: OrderFilter, outlets: string[] = []) => {
  const { startDate, endDate } = getDateRangeByFilter(filter);
  const matchQuery: any = {
    companyId: new BSON.ObjectID(companyId),
    createdAt: {
      $gte: startDate,
      $lte: endDate,
    },
  };

  if (outlets.length > 0) {
    const outletsWithObjectIds = outlets.map((outletId) => new BSON.ObjectId(outletId));
    matchQuery['posData'] = {
      $exists: true,
      $type: 'object',
    };
    matchQuery['posData.outlet'] = {
      $in: outletsWithObjectIds,
    };
  }

  return matchQuery;
};
